<template>
    <div id="base-info">
      <div class="content">
        <h2>基本信息</h2>
        <!--待优化 属性点的太深-->
        <table class="details" v-model="this.responseData.baseUserInfo.data.data">
          <tr><td>用户名:</td><td>{{this.responseData.baseUserInfo.data.data.username}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>昵称:</td><td>{{this.responseData.baseUserInfo.data.data.nickname}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>性别:</td><td>{{this.responseData.baseUserInfo.data.data.sex}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>生日:</td><td> {{this.responseData.baseUserInfo.data.data.birthday}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>座右铭:</td><td>{{this.responseData.baseUserInfo.data.data.motto}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>描述:</td><td>{{this.responseData.baseUserInfo.data.data.description}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>-</td><td>-</td> | <td>-</td><td>-</td></tr>
          <tr><td>绑定微信:</td><td>{{this.responseData.baseUserInfo.data.data.description}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>绑定QQ:</td><td>{{this.responseData.baseUserInfo.data.data.description}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>绑定支付宝:</td><td>{{this.responseData.baseUserInfo.data.data.description}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>绑定微博:</td><td>{{this.responseData.baseUserInfo.data.data.description}}</td> | <td>-</td><td>-</td></tr>
          <tr><td>绑定邮箱:</td><td>{{this.responseData.baseUserInfo.data.data.description}}</td> | <td>-</td><td>-</td></tr>
        </table>
      </div>
    </div>
</template>

<script>
  import HeadCommon from './../HeadCommon.vue'
  import FooterCommon from "../FooterCommon";
  import {sex} from "../../utils/Config";

    export default {
        name: "BaseInfo",
      data: function () {
        return {
          responseData: {
            baseUserInfo: {
              data: {
                code: 200,
                data: {
                  username: "",
                  id: null,
                  nickname: "雪域灰灰",
                  sex: sex.wei_zhi.value,
                  birthday: "",
                  motto: "保持本心,坚持不变",
                  description: "-",
                }
              }
            },
          }
        }
      },
      methods: {
        clickMore: function () {
          /*todo 判断是否拿到页数*/
          this.getPage = false;
          //this.pageSize = 0;
        },
        clickMoreLeave: function () {
          this.getPage = true;
          console.log(2)
        }
      },
      components: {
        FooterCommon,
        HeadCommon
      }
    }
</script>

<style scoped>
  div, img, ul, li, p, label, input {
    margin: 0 auto;
    padding: 0;
    border: 0;
  }
  #base-info {
    width: 1000px;
    border-style: dotted;
    border-color: aqua;
    background: rgba(204, 204, 204, 0.44);
  }
  #base-info .content {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
    float: left;
    margin: 0px;
    padding: 5px;
    text-align: center;
  }
  #base-info .content h2 {
    display: inline-block;
    margin: 20px;
    border-style: solid;
    border-color: #189dce;
    border-width: 0 0 2px 0;
    line-height: 2.5em;
    font-size: 1.25em;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    animation: border-color-move 4s infinite linear alternate;
  }
  /*规定动画*/
  @keyframes border-color-move {
    0% { border-color: #2fffbb;}
    25% { border-color: #ffdc51;}
    50% { border-color: #ff68e3;}
    75% { border-color: #2dccff;}
    100% { border-color: #34ff78;}
  }
</style>



// WEBPACK FOOTER //
// src/components/user/BaseInfo.vue